import { stringDate } from "./formatTime";

export const buildFortnightRangeOptions = (weeks = []) => {
  const map = new Map();

  weeks.forEach((w) => {
    const fortnight = String(w.number);
    const start = w?.startDate || w?.start_date;
    const end = w?.endDate || w?.end_date;

    if (!map.has(fortnight)) {
      map.set(fortnight, { start, end });
      return;
    }

    const current = map.get(fortnight);
    const startDate = new Date(start);
    const endDate = new Date(end);

    const currentStart = new Date(current.start);
    const currentEnd = new Date(current.end);

    if (startDate < currentStart) current.start = start;
    if (endDate > currentEnd) current.end = end;
  });

  return Array.from(map.entries())
    .sort(([a], [b]) => Number(a) - Number(b))
    .map(([fortnight, range]) => ({
      value: `${range.start},${range.end}`,
      label: `${fortnight}: ${stringDate(range.start)} - ${stringDate(
        range.end
      )}`,
    }));
};
